
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"69","height":"69","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"69","height":"69","rx":"34.5","fill":"#1BBAC8"}}),_c('path',{attrs:{"d":"M49.616 18.883c-.376 0-.734.158-.987.436L31.173 38.512a3 3 0 01-4.172.259l-6.705-5.75a1.405 1.405 0 00-.915-.338c-1.133 0-1.8 1.27-1.158 2.203l8.573 12.447c1.177 1.709 3.692 1.735 4.905.05L50.7 20.998c.636-.883.005-2.114-1.083-2.114z","fill":"#fff"}})])
          )
        }
      }
    